import React from "react";
import { currencyFormate } from "../Date_Formate_Utilitiy/Index";

const Total_Amount_Row_Sell_Purchase = ({ data }) => {
  return (
    <div className="col-12" style={{ height: 19.5 }}>
      <div className="row m-0 p-0 justify-content-end">
        <div
          className="col-2 p-0 pe-1 border_2_2px_top border_2_1px_bottom text-end"
          style={{ fontSize: 13, height: 19.5 }}
        >
          {data?.total_amount_item
            ? currencyFormate(data.total_amount_item)
            : ""}
        </div>
      </div>
    </div>
  );
};

export default Total_Amount_Row_Sell_Purchase;
